<template>
  <div :class="['notification-bar', barClass]">
    <div class="notification-bar-icon"><i :class="['fas', 'fa-2x', iconClass]"></i></div>
    <div class="notification-bar-content">
      <slot />
    </div>
    <div class="notification-bar-override" v-if="displayOverride">
      Override Warnings: <FormCheckbox class="ml-2" :value="overrideWarning" @change="overrideChanged" />
    </div>
  </div>
</template>

<style lang="scss">
.notification-bar {
  line-height: 1.8rem;
  padding: 0.8rem;
  margin-bottom: 1rem;
  position: relative;
  display: flex;
  border-radius: $layout-border-radius;
}
@media (max-width: 576px) {
  .notification-bar {
    text-align: center;
  }
}

.notification-bar-content {
  display: inline-block;
  vertical-align: top;
  padding: 0;
  margin-left: 1rem;
}
.theme-dark .notification-bar-content {
  color: #707070;
}
.notification-bar-info {
  background-color: #d5e5f3;
}
.notification-bar-success {
  background-color: #ECF4E8;
}
.notification-bar-error {
  background-color: #FEEFEF;
}
.theme-dark .notification-bar-error {
  background-color: #503d3d;
}
.theme-dark .modal-body .notification-bar-error {
  background-color: #997c7c;
}

.notification-bar-warning {
  background-color: #FFF0D7;
}

.notification-bar-info .notification-bar-icon {
  display: inline-block;
  color: #83a9cc;
}
.notification-bar-success .notification-bar-icon {
  display: inline-block;
  color: #b6e29e;
}
.notification-bar-error .notification-bar-icon {
  display: inline-block;
  color: #F6B0B4;
}
.theme-dark .modal-body .notification-bar-error .notification-bar-icon {
  color: #5c191f;
}
.notification-bar-warning .notification-bar-icon {
  display: inline-block;
  color: #FFCB90;
}
.notification-bar-override {
  display: inline-block;
  position: absolute;
  bottom: 0;
  right: 0.8rem;
}
.notification-bar .btn {
  font-size: 0.65rem;
  color: #9aa1a5;
}
.notification-bar p {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.notification-bar .well {
  border: 1px solid #e6e6e6;
  background-color: #f7f7f7;
  box-shadow: none;
  padding: 10px 20px;
  font-size: 11px;
  line-height: 16px;
}
.notification-bar-error .well {
  border: 1px solid #F6B0B4;
}
.notification-bar-warning .well {
  border: 1px solid #FFCB90;
}
.notification-bar-success .well {
  border: 1px solid #b6e29e;
}
.notification-bar-info .well {
  border: 1px solid #aac6e0;
}
.wizard-box-content .notification-bar {
  margin: 1rem;
}
.modal-content .notification-bar {
  margin: 0rem 0rem 1rem 0rem !important;
}
.notification-bar-content ul {
  margin-bottom: 0.5rem;
}
.notification-bar-content ul li {
  line-height: 0.95rem;
  margin-top: 0.30rem;
}
</style>

<script>
export default {
  name: 'NotificationBar',
  props: {
    type: {
      type: String,
      default: 'error',
    },
    displayOverride: Boolean,
    overrideWarning: Boolean,
  },
  computed: {
    barClass() {
      switch(this.type) {
        case 'info': return 'notification-bar-info'
        case 'success': return 'notification-bar-success'
        case 'error': return 'notification-bar-error'
        case 'warning': return 'notification-bar-warning'
        case 'pause': return 'notification-bar-error'
        default:
          return 'notification-bar-error'
      }
    },
    iconClass() {
      switch(this.type) {
        case 'info': return 'fa-info-circle'
        case 'success': return 'fa-check'
        case 'error': return 'fa-exclamation-circle'
        case 'warning': return 'fa-exclamation-triangle'
        case 'pause': return 'fa-pause-circle'
        default:
          return 'fa-exclamation-circle'
      }
    }
  },
  methods: {
    overrideChanged(value) {
      this.$emit('overrideUpdated', value)
    }
  }
}
</script>